/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { Typeahead, TypeaheadMenu } from "react-bootstrap-typeahead";
import { useIntl } from "react-intl";
import { useAsyncDebounce } from "react-table";

type SearchableTextFilterProps = {
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
  options?: any;
};

function SearchableTextFilter(props: SearchableTextFilterProps) {
  const { currentFilters, setFilters, filterKey, options = [] } = props;
  const intl = useIntl();
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    setSelected([currentFilters[filterKey] || ""]);
  }, [currentFilters[filterKey]]);

  const handleChange = useAsyncDebounce((value: string) => {
    setFilters({
      ...currentFilters,
      [filterKey]: value,
    });
  }, 500);

  return (
    <div className="text-filter" onClick={(e) => e.stopPropagation()}>
      <Typeahead
        inputProps={{ className: "filter-input" }}
        id={`searchable-text-filter-${filterKey}`}
        options={options}
        selected={selected}
        onChange={(value) => {
          if (!value?.length) {
            return;
          }
          setSelected(value);
          handleChange(value?.[0]);
        }}
        onInputChange={(text: string) => {
          setSelected([text]);
          handleChange(text);
        }}
        minLength={2}
        placeholder={
          intl.formatMessage({
            id: "general.typeHere",
            defaultMessage: "Type here...",
          }) as string
        }
        renderMenu={(results: any, menuProps: any) => {
          // Hide the menu when there are no results.
          if (!results.length) {
            return null;
          }
          return <TypeaheadMenu {...menuProps} options={results} />;
        }}
      />
    </div>
  );
}

export default SearchableTextFilter;

SearchableTextFilter.defaultProps = {
  options: [],
};
